import { render, staticRenderFns } from "./Passrule.vue?vue&type=template&id=02b4bb60&scoped=true&"
import script from "./Passrule.vue?vue&type=script&lang=js&"
export * from "./Passrule.vue?vue&type=script&lang=js&"
import style0 from "./Passrule.vue?vue&type=style&index=0&id=02b4bb60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b4bb60",
  null
  
)

export default component.exports